var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Profile_Picture",
    d: "M25.8906 29.9643C25.8935 31.2165 25.0058 32.2934 23.7813 32.5203C20.2232 33.17 16.6154 33.4985 13.0001 33.5C9.3878 33.4985 5.78138 33.1729 2.22753 32.5247C0.997086 32.3008 0.104966 31.221 0.109391 29.9643C0.112321 26.8396 1.34865 23.8444 3.54591 21.6348C5.74317 19.4249 8.72124 18.1816 11.8281 18.1786H14.1718C17.2788 18.1816 20.2569 19.4249 22.454 21.6348C24.6513 23.8446 25.8877 26.8397 25.8906 29.9643ZM13.0001 17.0001C15.1754 17.0001 17.2627 16.1309 18.8009 14.584C20.3392 13.0372 21.2032 10.9378 21.2032 8.75004C21.2032 6.56224 20.339 4.46307 18.8009 2.91604C17.2629 1.36901 15.1754 0.5 13.0001 0.5C10.8247 0.5 8.73748 1.3692 7.19924 2.91604C5.661 4.46289 4.79693 6.56224 4.79693 8.75004C4.79986 10.9378 5.66412 13.034 7.20221 14.581C8.74029 16.1279 10.8248 16.9971 13.0001 17.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profile-picture.d81c4381e686ac0e65563781d3d5e052.svg";
export { ForwardRef as ReactComponent };